import React from "react";
import { Container, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.svg";

const Header = () => {
  var splitUrl = window.location.href.split("/");
  return (
    <Navbar>
      <Container
        fluid
        className={`${
          splitUrl[3] === "signup" ? "" : "justify-content-center"
        }`}
      >
        <Link
          className={`${
            splitUrl[3] === "signup" ? "signup-logo z-index-99999" : ""
          } order-xl-first`}
          to={`/`}
        >
          <img src={Logo} alt="" />
        </Link>
      </Container>
    </Navbar>
  );
};

export default Header;
